import { SITE_URL } from './routes.js';

/**
 * Per-page document metadata.
 *
 * React 19 hoists <title>, <meta> and <link> into <head> wherever they are
 * rendered, so this needs no helmet library — it is plain JSX that happens to
 * end up in the right place.
 *
 * The prerender script writes the same tags into the static HTML at build time,
 * so a crawler that runs no JavaScript sees identical metadata. React
 * de-duplicates against what is already in the document on hydration.
 */
export default function Seo({ title, description, path = '/', noindex = false, jsonLd }) {
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph — what a link looks like when a parent shares it on
          WhatsApp, which for this audience is most of the traffic. */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Toddler's Academy" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${SITE_URL}/og-image.jpg`} />
      <meta
        property="og:image:alt"
        content="Children and a teacher outside Toddler's Academy"
      />
      <meta property="og:locale" content="en_NG" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE_URL}/og-image.jpg`} />

      {jsonLd && (
        <script
          type="application/ld+json"
          // Content is built from our own constants, never user input.
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}
